<template>
  <v-sheet>
    <v-app-bar
      flat
      color='rgba(0, 0, 0, 0)'
    >
      <v-toolbar-title flat class='title'>Local authority cycling statistics</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-card-text class="sub-text">
    The statistics below are taken from the Annual cycling monitoring report.
    A section of the report examines all the local authorities across Scotland and highlights
    key cycling statistics based on headline trends, workplaces and schools.
    The full reports can be found <a href="https://www.cycling.scot/what-we-do/making-cycling-better/monitoring-cycling-in-scotland" target="_blank">here.</a>
    </v-card-text>
    <v-row class="pa-4">
      <v-col cols='6'>
        <v-select
          :v-model='authority'
          :items='authorityList'
          :value="authority"
          v-on:change="SET_AUTHORITY"
          label='Local Authority'
          hint='Select a local authority'
          persistent-hint
          outlined
        ></v-select>
      </v-col>
      <v-col cols='6'>
        <v-select
          :v-model="year"
          :items='yearList'
          :value="year"
          v-on:change="SET_YEAR"
          label='Year'
          hint='Select a year'
          persistent-hint
          outlined
        ></v-select>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
// import iframeModal from '@/components/iframeModal.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    // iframeModal,
  },
  data() {
    return {
      authority: '',
      year: '',
    };
  },
  methods: {
    ...mapMutations(['SET_AUTHORITY', 'SET_YEAR']),
  },
  computed: {
    ...mapGetters(['authorityList', 'yearList', 'getSelectedYear', 'getSelectedAuthority']),
  },
  watch: {
    authorityList(n) {
      if (n) {
        const [first] = n;
        this.SET_AUTHORITY(first);
      }
    },
    yearList(n) {
      if (n) {
        const [first] = n;
        this.SET_YEAR(first);
      }
    },
    getSelectedAuthority(n) {
      if (n) {
        this.authority = n;
      }
    },
    getSelectedYear(n) {
      if (n) {
        this.year = n;
      }
    },
  },
};
</script>

<style>
.title {
  color: #5a5959;
  font-size: 18px;
  font-weight: bold;
}
</style>
